const mapAPIKey = import.meta.env.VITE_MAP_API_KEY;


export { mapAPIKey }









